var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTabletSearchIcon = function SvgTabletSearchIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M23.494 23.54a1.315 1.315 0 0 1 1.857 0l3.406 2.75h.06c.689.696.689 1.826 0 2.522a1.75 1.75 0 0 1-2.496 0l-2.827-3.24-.107-.12a1.445 1.445 0 0 1 .107-1.912m-9.39-20.872c3.033 0 5.942 1.218 8.087 3.386a11.62 11.62 0 0 1 3.35 8.174c0 6.384-5.121 11.56-11.437 11.56-6.317 0-11.437-5.176-11.437-11.56s5.12-11.56 11.437-11.56"
  })));
};
export default SvgTabletSearchIcon;